const AvatarImages = [
    {
        imageSrc: 'https://cdn.shopify.com/s/files/1/2338/2917/files/avatar-default-blue.png?v=1690397466',
        imageAlt: "Blue Cuddles avatar"
    },
    {
        imageSrc: 'https://cdn.shopify.com/s/files/1/2338/2917/files/avatar-default-neutral.png?v=1690397466',
        imageAlt: "Neutral Cuddles avatar"
    },
    {
        imageSrc: 'https://cdn.shopify.com/s/files/1/2338/2917/files/avatar-default-pink.png?v=1690397466',
        imageAlt: "Pink Cuddles avatar"
    },
    {
        imageSrc: 'https://cdn.shopify.com/s/files/1/2338/2917/files/avatar-default-yellow.png?v=1690397466',
        imageAlt: "Yellow Cuddles avatar"
    },
]

export default AvatarImages
